import User from '../user';

/**
 * Create the action
 */

const { thunk, request, success, error } = User.index((data, fetch) =>
  fetch.get(
    `/users?search=${data.search}${
      data.project_id ? `&project_id=${data.project_id}` : ''
    }${data.include_self ? `&include_self=1` : ''}${
      data.include_extern ? `&include_extern=1` : ''
    }`
  )
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
